<template>
  <div class="conv-composer" :class="{ 'conv-composer--sending': sending }">
    <textarea ref="input" :value="modelValue" class="conv-composer__input" rows="1" maxlength="2000"
      :placeholder="placeholder" :disabled="sending" aria-label="Votre message" @input="onInput"
      @keydown="onKeydown" />
    <v-btn icon size="small" variant="flat" color="#3f51b5" class="conv-composer__send" :loading="sending"
      :disabled="!canSend" title="Envoyer (Entrée)" aria-label="Envoyer le message" @click="send">
      <v-icon size="18" color="white" icon="mdi-send" />
    </v-btn>
  </div>
</template>

<script>
/**
 * Zone de saisie d'un message (style messagerie).
 * Entrée envoie, Maj + Entrée passe à la ligne (sur mobile, Entrée passe à la ligne).
 */
export default {
  name: "ConversationComposer",
  props: {
    modelValue: { type: String, default: "" },
    placeholder: { type: String, default: "Écrire un message…" },
    sending: { type: Boolean, default: false },
  },
  emits: ["update:modelValue", "send"],
  computed: {
    canSend() {
      return !this.sending && !!(this.modelValue || "").trim();
    },
  },
  watch: {
    modelValue() {
      this.$nextTick(this.autoGrow);
    },
  },
  mounted() {
    this.autoGrow();
  },
  methods: {
    onInput(e) {
      this.$emit("update:modelValue", e.target.value);
    },
    onKeydown(e) {
      if (e.key !== "Enter" || e.isComposing) return;
      const touch = window.matchMedia && window.matchMedia("(pointer: coarse)").matches;
      if (e.ctrlKey || e.metaKey || (!e.shiftKey && !touch)) {
        e.preventDefault();
        this.send();
      }
    },
    send() {
      if (this.canSend) this.$emit("send", this.modelValue.trim());
    },
    autoGrow() {
      const el = this.$refs.input;
      if (!el) return;
      el.style.height = "auto";
      el.style.height = `${Math.min(el.scrollHeight, 140)}px`;
    },
    focus() {
      if (this.$refs.input) this.$refs.input.focus();
    },
  },
};
</script>

<style scoped>
.conv-composer {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  width: 100%;
  padding: 5px 5px 5px 16px;
  border: 1px solid #dfe2ee;
  border-radius: 22px;
  background: #fff;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.conv-composer:focus-within {
  border-color: #3f51b5;
  box-shadow: 0 0 0 3px rgba(63, 81, 181, 0.12);
}

.conv-composer--sending {
  opacity: 0.8;
}

.conv-composer__input {
  flex: 1;
  min-width: 0;
  max-height: 140px;
  padding: 7px 0;
  border: 0;
  outline: none;
  resize: none;
  background: transparent;
  color: #1a1a2e;
  font: inherit;
  font-size: 14px;
  line-height: 20px;
  overflow-y: auto;
}

.conv-composer__input::placeholder {
  color: #9e9e9e;
}

.conv-composer__send {
  flex-shrink: 0;
}

/* 16px minimum : évite le zoom automatique d'iOS sur le champ */
@media (max-width: 600px) {
  .conv-composer__input {
    font-size: 16px;
  }
}
</style>
